/**
 * AgentCorp Theme Constants
 *
 * Local copy of theme constants from packages/agentcorp for use within src/
 * This avoids CRA's restriction on imports outside of src/
 */

// ===========================================
// CHARACTER CATEGORIES
// ===========================================

export const CHARACTER_CATEGORIES = {
  people: {
    id: 'people',
    name: 'People',
    description: 'Human avatar characters',
    icon: '👤',
    characters: [
      { id: 'person-1', name: 'Alex', emoji: '🧑', color: '#f59e0b', skinTone: 0, hairStyle: 0, shirtColor: 0 },
      { id: 'person-2', name: 'Jordan', emoji: '👩', color: '#ec4899', skinTone: 1, hairStyle: 1, shirtColor: 1 },
      { id: 'person-3', name: 'Sam', emoji: '👨', color: '#3b82f6', skinTone: 2, hairStyle: 2, shirtColor: 2 },
      { id: 'person-4', name: 'Taylor', emoji: '🧑‍🦱', color: '#8b5cf6', skinTone: 0, hairStyle: 3, shirtColor: 3 },
      { id: 'person-5', name: 'Morgan', emoji: '👩‍🦰', color: '#ef4444', skinTone: 1, hairStyle: 2, shirtColor: 4 },
      { id: 'person-6', name: 'Casey', emoji: '👨‍🦳', color: '#64748b', skinTone: 3, hairStyle: 4, shirtColor: 5 },
      { id: 'person-7', name: 'Riley', emoji: '👧', color: '#f472b6', skinTone: 0, hairStyle: 1, shirtColor: 1 },
      { id: 'person-8', name: 'Quinn', emoji: '👦', color: '#10b981', skinTone: 2, hairStyle: 0, shirtColor: 2 },
    ],
  },
  professionals: {
    id: 'professionals',
    name: 'Professionals',
    description: 'Business and work avatars',
    icon: '👔',
    characters: [
      { id: 'pro-1', name: 'Emma', emoji: '👩‍💼', color: '#7c3aed', skinTone: 1, hairStyle: 1, shirtColor: 3 },
      { id: 'pro-2', name: 'Liam', emoji: '👨‍💼', color: '#1e40af', skinTone: 0, hairStyle: 0, shirtColor: 0 },
      { id: 'pro-3', name: 'Sophia', emoji: '👩‍💻', color: '#059669', skinTone: 2, hairStyle: 2, shirtColor: 2 },
      { id: 'pro-4', name: 'Noah', emoji: '👨‍💻', color: '#0891b2', skinTone: 1, hairStyle: 3, shirtColor: 4 },
      { id: 'pro-5', name: 'Olivia', emoji: '👩‍🔬', color: '#dc2626', skinTone: 0, hairStyle: 1, shirtColor: 1 },
      { id: 'pro-6', name: 'James', emoji: '👨‍🏫', color: '#4f46e5', skinTone: 3, hairStyle: 4, shirtColor: 3 },
      { id: 'pro-7', name: 'Ava', emoji: '👩‍🎨', color: '#db2777', skinTone: 1, hairStyle: 2, shirtColor: 4 },
      { id: 'pro-8', name: 'William', emoji: '🧑‍⚕️', color: '#22c55e', skinTone: 2, hairStyle: 0, shirtColor: 2 },
    ],
  },
  robots: {
    id: 'robots',
    name: 'Robots',
    description: 'AI assistants and mechanical helpers',
    icon: '🤖',
    characters: [
      { id: 'bot-red', name: 'Ruby', emoji: '🤖', color: '#ff4d4d' },
      { id: 'bot-blue', name: 'Azure', emoji: '🤖', color: '#3b82f6' },
      { id: 'bot-green', name: 'Sage', emoji: '🤖', color: '#10b981' },
      { id: 'bot-purple', name: 'Violet', emoji: '🤖', color: '#8b5cf6' },
      { id: 'bot-orange', name: 'Amber', emoji: '🤖', color: '#f59e0b' },
      { id: 'bot-gray', name: 'Steel', emoji: '🤖', color: '#64748b' },
    ],
  },
  animals: {
    id: 'animals',
    name: 'Animals',
    description: 'Cute animal assistants',
    icon: '🐾',
    characters: [
      { id: 'cat', name: 'Whiskers', emoji: '🐱', color: '#f59e0b' },
      { id: 'dog', name: 'Buddy', emoji: '🐶', color: '#8b4513' },
      { id: 'fox', name: 'Firefox', emoji: '🦊', color: '#ea580c' },
      { id: 'owl', name: 'Hoot', emoji: '🦉', color: '#78716c' },
      { id: 'panda', name: 'Bamboo', emoji: '🐼', color: '#1f2937' },
      { id: 'bunny', name: 'Hoppy', emoji: '🐰', color: '#fda4af' },
      { id: 'bear', name: 'Teddy', emoji: '🐻', color: '#92400e' },
      { id: 'koala', name: 'Eucaly', emoji: '🐨', color: '#6b7280' },
    ],
  },
  fantasy: {
    id: 'fantasy',
    name: 'Fantasy',
    description: 'Magical creatures and heroes',
    icon: '✨',
    characters: [
      { id: 'wizard', name: 'Merlin', emoji: '🧙', color: '#7c3aed', skinTone: 0, hairStyle: 4, shirtColor: 3 },
      { id: 'fairy', name: 'Pixie', emoji: '🧚', color: '#ec4899', skinTone: 1, hairStyle: 1, shirtColor: 4 },
      { id: 'vampire', name: 'Count', emoji: '🧛', color: '#dc2626', skinTone: 0, hairStyle: 0, shirtColor: 5 },
      { id: 'genie', name: 'Wishy', emoji: '🧞', color: '#06b6d4' },
      { id: 'mermaid', name: 'Marina', emoji: '🧜‍♀️', color: '#0891b2', skinTone: 1, hairStyle: 2, shirtColor: 4 },
      { id: 'superhero', name: 'Hero', emoji: '🦸', color: '#2563eb', skinTone: 2, hairStyle: 0, shirtColor: 1 },
      { id: 'elf', name: 'Elva', emoji: '🧝', color: '#22c55e', skinTone: 0, hairStyle: 1, shirtColor: 2 },
      { id: 'ninja', name: 'Shadow', emoji: '🥷', color: '#1f2937', skinTone: 2, hairStyle: 0, shirtColor: 5 },
    ],
  },
  space: {
    id: 'space',
    name: 'Space',
    description: 'Astronauts and aliens',
    icon: '🚀',
    characters: [
      { id: 'astronaut-m', name: 'Neil', emoji: '👨‍🚀', color: '#f8fafc', skinTone: 0, hairStyle: 0, shirtColor: 0 },
      { id: 'astronaut-f', name: 'Sally', emoji: '👩‍🚀', color: '#a78bfa', skinTone: 1, hairStyle: 1, shirtColor: 3 },
      { id: 'alien-1', name: 'Zorp', emoji: '👽', color: '#22c55e' },
      { id: 'alien-2', name: 'Blip', emoji: '👾', color: '#8b5cf6' },
      { id: 'robot-space', name: 'R2', emoji: '🤖', color: '#64748b' },
    ],
  },
  emoji: {
    id: 'emoji',
    name: 'Emoji Faces',
    description: 'Expressive emoji characters',
    icon: '😊',
    characters: [
      { id: 'smile', name: 'Happy', emoji: '😊', color: '#fbbf24' },
      { id: 'cool', name: 'Cool', emoji: '😎', color: '#3b82f6' },
      { id: 'nerd', name: 'Nerdy', emoji: '🤓', color: '#8b5cf6' },
      { id: 'wink', name: 'Wink', emoji: '😉', color: '#f59e0b' },
      { id: 'star-eyes', name: 'Starry', emoji: '🤩', color: '#ec4899' },
      { id: 'think', name: 'Thinky', emoji: '🤔', color: '#64748b' },
      { id: 'angel', name: 'Angel', emoji: '😇', color: '#06b6d4' },
      { id: 'party', name: 'Party', emoji: '🥳', color: '#a855f7' },
    ],
  },
  superheroes: {
    id: 'superheroes',
    name: 'Superheroes',
    description: 'Comic-book energy for heroic support teams',
    icon: '🦸',
    characters: [
      { id: 'hero-captain', name: 'Captain Volt', emoji: '🦸‍♂️', color: '#2563eb', skinTone: 1, hairStyle: 0, shirtColor: 0 },
      { id: 'hero-starlight', name: 'Starlight', emoji: '🦸‍♀️', color: '#ec4899', skinTone: 0, hairStyle: 2, shirtColor: 4 },
      { id: 'hero-meteor', name: 'Meteor', emoji: '🦸', color: '#f59e0b', skinTone: 2, hairStyle: 1, shirtColor: 3 },
      { id: 'hero-shadow', name: 'Shadowbyte', emoji: '🥷', color: '#1f2937', skinTone: 3, hairStyle: 4, shirtColor: 5 },
    ],
  },
  legends: {
    id: 'legends',
    name: 'Legends',
    description: 'Historical and adventurous personas',
    icon: '🏴‍☠️',
    characters: [
      { id: 'legend-pirate', name: 'Captain Tide', emoji: '🏴‍☠️', color: '#92400e' },
      { id: 'legend-knight', name: 'Sir Pixel', emoji: '🫅', color: '#64748b', skinTone: 1, hairStyle: 3, shirtColor: 0 },
      { id: 'legend-samurai', name: 'Kaito', emoji: '🥷', color: '#dc2626', skinTone: 2, hairStyle: 0, shirtColor: 5 },
      { id: 'legend-viking', name: 'Freya', emoji: '🛡️', color: '#0f766e' },
    ],
  },
  sports: {
    id: 'sports',
    name: 'Sports',
    description: 'High-energy athletes and coaches',
    icon: '🏅',
    characters: [
      { id: 'sport-runner', name: 'Dash', emoji: '🏃', color: '#ef4444', skinTone: 1, hairStyle: 0, shirtColor: 1 },
      { id: 'sport-baller', name: 'Ace', emoji: '⛹️', color: '#f97316', skinTone: 2, hairStyle: 2, shirtColor: 3 },
      { id: 'sport-coach', name: 'Coach Nova', emoji: '🧑‍🏫', color: '#2563eb', skinTone: 0, hairStyle: 4, shirtColor: 0 },
      { id: 'sport-winner', name: 'Victory', emoji: '🏄', color: '#06b6d4', skinTone: 1, hairStyle: 1, shirtColor: 2 },
    ],
  },
  music: {
    id: 'music',
    name: 'Music',
    description: 'Performers, DJs, and studio personalities',
    icon: '🎵',
    characters: [
      { id: 'music-dj', name: 'DJ Echo', emoji: '🧑‍🎤', color: '#8b5cf6', skinTone: 1, hairStyle: 4, shirtColor: 4 },
      { id: 'music-rock', name: 'Riff', emoji: '👨‍🎤', color: '#ef4444', skinTone: 2, hairStyle: 0, shirtColor: 5 },
      { id: 'music-pop', name: 'Lyra', emoji: '👩‍🎤', color: '#ec4899', skinTone: 0, hairStyle: 2, shirtColor: 1 },
      { id: 'music-orchestra', name: 'Maestro', emoji: '🎻', color: '#1d4ed8' },
    ],
  },
  mascots: {
    id: 'mascots',
    name: 'Mascots',
    description: 'Cute brand-friendly characters and food pals',
    icon: '🍩',
    characters: [
      { id: 'mascot-donut', name: 'Glazy', emoji: '🍩', color: '#fb7185' },
      { id: 'mascot-boba', name: 'Bubbles', emoji: '🧋', color: '#7c3aed' },
      { id: 'mascot-burger', name: 'Patty', emoji: '🍔', color: '#f59e0b' },
      { id: 'mascot-ramen', name: 'Nori', emoji: '🍜', color: '#22c55e' },
    ],
  },
  seasonal: {
    id: 'seasonal',
    name: 'Seasonal',
    description: 'Holiday and seasonal costumes',
    icon: '🎄',
    characters: [
      { id: 'season-santa', name: 'Santa Bot', emoji: '🎅', color: '#dc2626', skinTone: 0, hairStyle: 4, shirtColor: 1 },
      { id: 'season-bunny', name: 'Sunny Hop', emoji: '🐣', color: '#fbbf24' },
      { id: 'season-spooky', name: 'Midnight', emoji: '🧙‍♀️', color: '#7c3aed', skinTone: 1, hairStyle: 1, shirtColor: 4 },
      { id: 'season-summer', name: 'Breeze', emoji: '🕶️', color: '#0ea5e9' },
    ],
  },
  service: {
    id: 'service',
    name: 'Service Teams',
    description: 'Frontline specialists and helpful experts',
    icon: '🚒',
    characters: [
      { id: 'service-doctor', name: 'Dr. Nova', emoji: '🧑‍⚕️', color: '#3b82f6', skinTone: 1, hairStyle: 2, shirtColor: 0 },
      { id: 'service-chef', name: 'Chef Byte', emoji: '🧑‍🍳', color: '#f97316', skinTone: 0, hairStyle: 4, shirtColor: 3 },
      { id: 'service-fire', name: 'Blaze', emoji: '👨‍🚒', color: '#ef4444', skinTone: 2, hairStyle: 0, shirtColor: 1 },
      { id: 'service-detective', name: 'Scout', emoji: '👮', color: '#0f766e', skinTone: 3, hairStyle: 1, shirtColor: 2 },
    ],
  },
  mythical: {
    id: 'mythical',
    name: 'Mythical',
    description: 'Legendary creatures and magical beings',
    icon: '🐉',
    characters: [
      { id: 'myth-unicorn', name: 'Prism', emoji: '🦄', color: '#ec4899' },
      { id: 'myth-dragon', name: 'Emberwing', emoji: '🐉', color: '#10b981' },
      { id: 'myth-phoenix', name: 'Sol', emoji: '🔥', color: '#f97316' },
      { id: 'myth-merfolk', name: 'Ripple', emoji: '🧜', color: '#06b6d4', skinTone: 1, hairStyle: 3, shirtColor: 2 },
    ],
  },
};

// ===========================================
// ART STYLES
// ===========================================

export const ART_STYLES = {
  modern: {
    id: 'modern',
    name: 'Modern',
    description: 'Clean, professional design',
    preview: 'bg-gradient-to-br from-slate-800 to-slate-900',
    avatarStyle: {
      shape: 'rounded-2xl',
      border: 'border-2',
      shadow: 'shadow-lg',
      gradient: true,
    },
    deskStyle: {
      shape: 'rounded-xl',
      effect: 'bg-gradient-to-r',
    },
  },
  pixel: {
    id: 'pixel',
    name: 'Pixel Art',
    description: '8-bit retro gaming style',
    preview: 'bg-[#2d1b69]',
    avatarStyle: {
      shape: 'rounded-none',
      border: 'border-4 border-black',
      shadow: 'shadow-[4px_4px_0px_0px_rgba(0,0,0,1)]',
      gradient: false,
      pixelated: true,
    },
    deskStyle: {
      shape: 'rounded-none',
      effect: 'border-4 border-black',
    },
    fontFamily: '"Press Start 2P", monospace',
  },
  chibi: {
    id: 'chibi',
    name: 'Chibi',
    description: 'Cute anime-style characters',
    preview: 'bg-gradient-to-br from-pink-200 to-purple-300',
    avatarStyle: {
      shape: 'rounded-full',
      border: 'border-4 border-white',
      shadow: 'shadow-xl',
      gradient: true,
      oversized: true,
    },
    deskStyle: {
      shape: 'rounded-2xl',
      effect: 'bg-white/30 backdrop-blur',
    },
  },
  roblox: {
    id: 'roblox',
    name: 'Roblox',
    description: 'Blocky game characters',
    preview: 'bg-gradient-to-br from-[#00a2ff] to-[#0066cc]',
    avatarStyle: {
      shape: 'rounded-lg',
      border: 'border-4 border-black/20',
      shadow: 'shadow-[0_8px_0px_0px_rgba(0,0,0,0.2)]',
      gradient: false,
      blocky: true,
    },
    deskStyle: {
      shape: 'rounded-lg',
      effect: 'border-b-4 border-black/20',
    },
  },
  minecraft: {
    id: 'minecraft',
    name: 'Minecraft',
    description: 'Blocky voxel style',
    preview: 'bg-[#7bc96f]',
    avatarStyle: {
      shape: 'rounded-none',
      border: 'border-2 border-[#3d3d3d]',
      shadow: 'shadow-[inset_-2px_-4px_0px_0px_rgba(0,0,0,0.3)]',
      gradient: false,
      pixelated: true,
      blocky: true,
    },
    deskStyle: {
      shape: 'rounded-none',
      effect: 'border-2 border-[#3d3d3d]',
    },
  },
  neon: {
    id: 'neon',
    name: 'Neon Cyberpunk',
    description: 'Glowing futuristic style',
    preview: 'bg-black',
    avatarStyle: {
      shape: 'rounded-xl',
      border: 'border-2',
      shadow: '',
      gradient: false,
      glow: true,
    },
    deskStyle: {
      shape: 'rounded-xl',
      effect: 'border-t-2',
    },
  },
  kawaii: {
    id: 'kawaii',
    name: 'Kawaii',
    description: 'Super cute Japanese style',
    preview: 'bg-gradient-to-br from-[#ffb7c5] to-[#ffd1dc]',
    avatarStyle: {
      shape: 'rounded-[2rem]',
      border: 'border-4 border-white',
      shadow: 'shadow-lg',
      gradient: true,
      bouncy: true,
    },
    deskStyle: {
      shape: 'rounded-2xl',
      effect: 'bg-white/50',
    },
  },
  minimal: {
    id: 'minimal',
    name: 'Minimal',
    description: 'Clean and simple',
    preview: 'bg-white',
    avatarStyle: {
      shape: 'rounded-full',
      border: 'border border-gray-200',
      shadow: '',
      gradient: false,
    },
    deskStyle: {
      shape: 'rounded-lg',
      effect: 'border border-gray-200',
    },
    lightMode: true,
  },
};

// ===========================================
// OFFICE BACKGROUNDS
// ===========================================

export const OFFICE_BACKGROUNDS = {
  default: {
    id: 'default',
    name: 'Dark Office',
    className: 'bg-[#050810]',
  },
  gradient: {
    id: 'gradient',
    name: 'Gradient',
    className: 'bg-gradient-to-br from-[#0a0f1c] to-[#1a0a0a]',
  },
  space: {
    id: 'space',
    name: 'Space',
    className: 'bg-gradient-to-b from-[#0f0c29] via-[#302b63] to-[#24243e]',
  },
  forest: {
    id: 'forest',
    name: 'Forest',
    className: 'bg-gradient-to-br from-[#134e4a] to-[#064e3b]',
  },
  sunset: {
    id: 'sunset',
    name: 'Sunset',
    className: 'bg-gradient-to-br from-[#7c2d12] via-[#9a3412] to-[#c2410c]',
  },
  ocean: {
    id: 'ocean',
    name: 'Ocean',
    className: 'bg-gradient-to-br from-[#0c4a6e] to-[#164e63]',
  },
  candy: {
    id: 'candy',
    name: 'Candy',
    className: 'bg-gradient-to-br from-[#ec4899] via-[#8b5cf6] to-[#06b6d4]',
  },
  minecraft: {
    id: 'minecraft',
    name: 'Grass Block',
    className: 'bg-[#5d8731]',
    pattern: 'minecraft-grass',
  },
  pixel: {
    id: 'pixel',
    name: 'Pixel Grid',
    className: 'bg-[#1a1a2e]',
    pattern: 'pixel-grid',
  },
  aurora: {
    id: 'aurora',
    name: 'Aurora',
    className: 'bg-gradient-to-br from-[#071426] via-[#0d3b66] to-[#1d7a85]',
  },
  city: {
    id: 'city',
    name: 'City Lights',
    className: 'bg-gradient-to-br from-[#111827] via-[#1f2937] to-[#4338ca]',
  },
  garden: {
    id: 'garden',
    name: 'Garden',
    className: 'bg-gradient-to-br from-[#14532d] via-[#3f6212] to-[#84cc16]',
  },
};

// ===========================================
// OFFICE ENVIRONMENTS
// ===========================================

export const OFFICE_ENVIRONMENTS = {
  corporate: {
    id: 'corporate',
    name: 'Corporate Office',
    description: 'Professional workspace with modern furniture',
    icon: '🏢',
    furniture: {
      desk: { emoji: '🖥️', style: 'modern' },
      chair: { emoji: '🪑', style: 'ergonomic' },
      plant: { emoji: '🪴', position: 'corner' },
      lamp: { emoji: '💡', position: 'desk' },
    },
    colors: {
      primary: '#1e293b',
      secondary: '#334155',
      accent: '#3b82f6',
    },
    ambiance: 'professional',
  },
  homeCozy: {
    id: 'homeCozy',
    name: 'Cozy Home Office',
    description: 'Comfortable work-from-home setup',
    icon: '🏠',
    furniture: {
      desk: { emoji: '📚', style: 'wooden' },
      chair: { emoji: '🛋️', style: 'comfy' },
      plant: { emoji: '🌿', position: 'windowsill' },
      mug: { emoji: '☕', position: 'desk' },
      cat: { emoji: '🐱', position: 'sleeping' },
    },
    colors: {
      primary: '#78350f',
      secondary: '#92400e',
      accent: '#f59e0b',
    },
    ambiance: 'warm',
  },
  gaming: {
    id: 'gaming',
    name: 'Gaming Setup',
    description: 'RGB-lit gaming station',
    icon: '🎮',
    furniture: {
      desk: { emoji: '🖥️', style: 'rgb' },
      chair: { emoji: '🎮', style: 'gaming' },
      led: { emoji: '💜', position: 'background' },
      headset: { emoji: '🎧', position: 'desk' },
    },
    colors: {
      primary: '#0f0f1a',
      secondary: '#1a1a2e',
      accent: '#8b5cf6',
    },
    ambiance: 'energetic',
  },
  cafe: {
    id: 'cafe',
    name: 'Coffee Shop',
    description: 'Cafe workspace vibes',
    icon: '☕',
    furniture: {
      table: { emoji: '🪑', style: 'cafe' },
      coffee: { emoji: '☕', position: 'table' },
      pastry: { emoji: '🥐', position: 'table' },
      plant: { emoji: '🌱', position: 'window' },
    },
    colors: {
      primary: '#451a03',
      secondary: '#78350f',
      accent: '#d97706',
    },
    ambiance: 'cozy',
  },
  beach: {
    id: 'beach',
    name: 'Beach Office',
    description: 'Working from paradise',
    icon: '🏖️',
    furniture: {
      hammock: { emoji: '🏖️', style: 'relaxed' },
      umbrella: { emoji: '⛱️', position: 'overhead' },
      coconut: { emoji: '🥥', position: 'side' },
      laptop: { emoji: '💻', position: 'lap' },
    },
    colors: {
      primary: '#0e7490',
      secondary: '#06b6d4',
      accent: '#fbbf24',
    },
    ambiance: 'relaxed',
  },
  space: {
    id: 'space',
    name: 'Space Station',
    description: 'Orbital command center',
    icon: '🚀',
    furniture: {
      console: { emoji: '🖥️', style: 'holographic' },
      pod: { emoji: '🛸', style: 'floating' },
      stars: { emoji: '✨', position: 'window' },
      earth: { emoji: '🌍', position: 'view' },
    },
    colors: {
      primary: '#020617',
      secondary: '#0f172a',
      accent: '#06b6d4',
    },
    ambiance: 'futuristic',
  },
  japanese: {
    id: 'japanese',
    name: 'Japanese Room',
    description: 'Zen minimalist workspace',
    icon: '🎌',
    furniture: {
      tatami: { emoji: '🟫', style: 'floor' },
      lowTable: { emoji: '📦', style: 'kotatsu' },
      bonsai: { emoji: '🌳', position: 'corner' },
      tea: { emoji: '🍵', position: 'table' },
    },
    colors: {
      primary: '#1c1917',
      secondary: '#292524',
      accent: '#dc2626',
    },
    ambiance: 'zen',
  },
  classroom: {
    id: 'classroom',
    name: 'Classroom',
    description: 'School/training environment',
    icon: '🏫',
    furniture: {
      desk: { emoji: '📝', style: 'school' },
      chair: { emoji: '🪑', style: 'plastic' },
      board: { emoji: '📋', position: 'front' },
      apple: { emoji: '🍎', position: 'desk' },
    },
    colors: {
      primary: '#365314',
      secondary: '#3f6212',
      accent: '#84cc16',
    },
    ambiance: 'educational',
  },
};

// ===========================================
// THEME PRESETS
// ===========================================

export const THEME_PRESETS = [
  {
    id: 'corporate',
    name: 'Corporate Office',
    description: 'Professional business environment',
    category: 'professionals',
    artStyle: 'modern',
    background: 'default',
    preview: 'bg-gradient-to-br from-[#1e293b] to-[#0f172a]',
  },
  {
    id: 'arcade',
    name: 'Pixel Arcade',
    description: 'Retro 8-bit gaming vibes',
    category: 'emoji',
    artStyle: 'pixel',
    background: 'pixel',
    preview: 'bg-[#2d1b69]',
  },
  {
    id: 'pet-shop',
    name: 'Pet Shop',
    description: 'Cute animal helpers',
    category: 'animals',
    artStyle: 'chibi',
    background: 'candy',
    preview: 'bg-gradient-to-br from-[#fda4af] to-[#c4b5fd]',
  },
  {
    id: 'roblox-hq',
    name: 'Roblox HQ',
    description: 'Blocky game world',
    category: 'people',
    artStyle: 'roblox',
    background: 'ocean',
    preview: 'bg-[#00a2ff]',
  },
  {
    id: 'minecraft-village',
    name: 'Minecraft Village',
    description: 'Voxel crafting world',
    category: 'animals',
    artStyle: 'minecraft',
    background: 'minecraft',
    preview: 'bg-[#5d8731]',
  },
  {
    id: 'cyber-city',
    name: 'Cyber City',
    description: 'Neon-lit futuristic office',
    category: 'robots',
    artStyle: 'neon',
    background: 'default',
    preview: 'bg-black',
  },
  {
    id: 'magic-kingdom',
    name: 'Magic Kingdom',
    description: 'Fantasy wizard tower',
    category: 'fantasy',
    artStyle: 'kawaii',
    background: 'sunset',
    preview: 'bg-gradient-to-br from-[#7c3aed] to-[#c026d3]',
  },
  {
    id: 'space-station',
    name: 'Space Station',
    description: 'Galactic command center',
    category: 'space',
    artStyle: 'modern',
    background: 'space',
    preview: 'bg-gradient-to-b from-[#0f0c29] to-[#24243e]',
  },
  {
    id: 'emoji-team',
    name: 'Emoji Team',
    description: 'Expressive emoji agents',
    category: 'emoji',
    artStyle: 'kawaii',
    background: 'candy',
    preview: 'bg-gradient-to-br from-[#ffb7c5] to-[#ffd1dc]',
  },
  {
    id: 'hero-hub',
    name: 'Hero Hub',
    description: 'Comic-book customer success squad',
    category: 'superheroes',
    artStyle: 'neon',
    background: 'city',
    preview: 'bg-gradient-to-br from-[#1d4ed8] to-[#ec4899]',
  },
  {
    id: 'festival-hq',
    name: 'Festival HQ',
    description: 'Bright mascot-filled office party',
    category: 'mascots',
    artStyle: 'kawaii',
    background: 'aurora',
    preview: 'bg-gradient-to-br from-[#fb7185] to-[#22d3ee]',
  },
  {
    id: 'mythic-ops',
    name: 'Mythic Ops',
    description: 'Legendary creatures in a magical control room',
    category: 'mythical',
    artStyle: 'modern',
    background: 'garden',
    preview: 'bg-gradient-to-br from-[#0f766e] to-[#f59e0b]',
  },
  {
    id: 'all-star-support',
    name: 'All-Star Support',
    description: 'Sports arena inspired office energy',
    category: 'sports',
    artStyle: 'roblox',
    background: 'ocean',
    preview: 'bg-gradient-to-br from-[#0ea5e9] to-[#f97316]',
  },
];

// ===========================================
// CHANNELS
// ===========================================

export const CHANNELS = {
  all: { id: 'all', name: 'All Channels', icon: '📱', color: '#64748b' },
  zalo: { id: 'zalo', name: 'Zalo', icon: '💬', color: '#0068ff' },
  telegram: { id: 'telegram', name: 'Telegram', icon: '✈️', color: '#0088cc' },
  facebook: { id: 'facebook', name: 'Facebook', icon: '📘', color: '#1877f2' },
  whatsapp: { id: 'whatsapp', name: 'WhatsApp', icon: '💚', color: '#25d366' },
  slack: { id: 'slack', name: 'Slack', icon: '💼', color: '#4a154b' },
  discord: { id: 'discord', name: 'Discord', icon: '🎮', color: '#5865f2' },
  webchat: { id: 'webchat', name: 'Web Chat', icon: '🌐', color: '#3b82f6' },
};

export default {
  CHARACTER_CATEGORIES,
  ART_STYLES,
  OFFICE_BACKGROUNDS,
  OFFICE_ENVIRONMENTS,
  THEME_PRESETS,
  CHANNELS,
};
